// extracted by mini-css-extract-plugin
export default {"root":"_2gmF9","variant-subscriptions":"OSxdQ","variantSubscriptions":"OSxdQ","variant-adoptables":"_1J4JB","variantAdoptables":"_1J4JB"};